import { isEmpty } from 'lodash';

const getHostAccountPromoResponse = (response) => {
  if (isEmpty(response?.data?.stores)) return [];

  return response.data.stores.map((item) => ({
    value: item?.storeName,
    label: item?.storeName,
    name: item?.storeName,
    ecommerce: {
      name: item?.ecommerce?.name,
      color: item?.ecommerce?.color,
      logo: item?.ecommerce?.logo,
    },
  }));
};

export default getHostAccountPromoResponse;
